import {Component} from '@angular/core';
import {PrimeNgImportsModule} from '../../../../sdk/src/prime-ng-imports';
import {OrganizationCRUDComponent} from '../../components/organization/organization-crud/organization-crud.component';
import {IBasePageComponent} from '../../../../sdk/src/components/ibase-page/ibase-page.component';
import {CustomerOrganizationsNumbersComponent} from '../../components/customer-organizations-numbers/customer-organizations-numbers.component';

@Component({
    selector: 'app-co-instances-page',
    templateUrl: './co-instances-page.component.html',
    imports: [PrimeNgImportsModule, OrganizationCRUDComponent, CustomerOrganizationsNumbersComponent]
})
export class COInstancesPageComponent extends IBasePageComponent {
    /**
     * On ready (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onReady(): Promise<void> {}
    /**
     * On destroy (Error handling and refresh is done in the parent)
     */
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    protected override async onDestroy(): Promise<void> {}
}
